<template>
    <div>
        <p>
            V nejbližší době vás budeme kontaktovat ohledně nabídky a nastavení
            vašich služeb. vyberte způsob úhrady a pak pokračujte do servisní
            sekce, kde můžete dokončit nastavení vaší firmy.
        </p>

        <div class="row mt-5">
            <button class="button-02" @click="setOfferRequest()">
                Pokračovat
            </button>
        </div>
    </div>
</template>

<script>
export default {
    computed: {
        firm() {
            return this.$store.state.firm
        },
    },
    methods: {
        setOfferRequest() {
            this.$store
                .dispatch('firm/setOfferRequest')
                .then(() => {
                    this.$store.dispatch(
                        'loader/setLoader',
                        `Žádost o nabídku odeslána.`
                    )
                })
                .catch(error => {
                    console.log(error)
                    this.$store.dispatch('loader/setError', error)
                })
            // prejde do servisky
            window.location.href = `http://scripts.ci.cz/toSS.php?web=ceskestavby&fid=${this.firm.result.id_firmy}&ftoken=${this.firm.result.opravny_kod}`
        },
    },
}
</script>
